module.exports = __webpack_public_path__ + "img/logo-nen-tim.072fcba4.png";